import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { RescheduleWindowClosedContainer } = await import('@containers/Payment/ErrorScreens/RescheduleWindowClosed');
    return {
        Component: RescheduleWindowClosedContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
